export const DynamicIconColor = {
  widgetHeaderFilterIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6479 8.51185C24.7803 7.18056 23.8342 5.13359 22.0864 5.13359H8.10341C6.35561 5.13359 5.40947 7.18055 6.54192 8.51185L12.2139 15.1798V20.1263C12.2139 20.9045 12.6546 21.6156 13.3514 21.962L15.0134 22.7881C16.3762 23.4655 17.9759 22.4743 17.9759 20.9524V15.1798L23.6479 8.51185Z"
        stroke="var(--nonactionable-icon-color,#fff)"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  CommandCenterRefreshIcon: (
    <svg
      class="my-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 16 16"
    >
      <path
        d="M7.762,4.857a5.6,5.6,0,0,0-4.108,1.7,5.6,5.6,0,0,0-1.7,4.108,5.681,5.681,0,0,0,.681,2.723L1.18,14.8A7.7,7.7,0,0,1,0,10.667,7.481,7.481,0,0,1,2.27,5.174,7.481,7.481,0,0,1,7.762,2.9V0L11.62,3.9,7.762,7.762ZM14.3,6.536a7.7,7.7,0,0,1,1.18,4.13,7.481,7.481,0,0,1-2.27,5.492,7.428,7.428,0,0,1-5.447,2.27v2.9l-3.9-3.9,3.9-3.858v2.9a5.6,5.6,0,0,0,4.108-1.7,5.6,5.6,0,0,0,1.7-4.108,5.857,5.857,0,0,0-.681-2.723Z"
        fill="var(--nonactionable-icon-color,#fff)"
        transform="translate(10.07 -5.015) rotate(45)"
      />
    </svg>
  ),
  widgetHeaderFilterHoveredIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 30 29"
      fill="none"
    >
      <path
        d="M23.6479 8.51185C24.7803 7.18056 23.8342 5.13359 22.0864 5.13359H8.10341C6.35561 5.13359 5.40947 7.18055 6.54192 8.51185L12.2139 15.1798V20.1263C12.2139 20.9045 12.6546 21.6156 13.3514 21.962L15.0134 22.7881C16.3762 23.4655 17.9759 22.4743 17.9759 20.9524V15.1798L23.6479 8.51185Z"
        stroke="var(--nonactionable-icon-color,rgb(103,139,255))"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  SettingsHoveredIcon: (
    //#678BFF
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_680_543)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0194 19.1651C9.06613 19.1714 8.18989 18.6331 7.76522 17.7817L7.37134 16.9939C7.21613 16.9363 7.06343 16.8731 6.91236 16.8051L6.07741 17.0834C5.1754 17.3845 4.17424 17.1458 3.50583 16.4666C2.84707 15.797 2.62093 14.8113 2.91827 13.9227L3.19659 13.0893C3.1271 12.9372 3.06208 12.7835 3.00291 12.6271L2.21841 12.2349C1.36785 11.8106 0.827994 10.9352 0.834967 9.98228C0.841842 9.04276 1.37855 8.18572 2.21679 7.76714L3.00616 7.37001C3.06403 7.21474 3.12696 7.06199 3.19496 6.91103L2.91827 6.07771C2.61747 5.17655 2.85543 4.17628 3.5335 3.50775C4.20251 2.84814 5.18828 2.62185 6.07741 2.91857L6.91074 3.19526C7.06267 3.12597 7.21675 3.06241 7.37297 3.0032L7.76522 2.22034C8.18989 1.36885 9.06613 0.829426 10.0194 0.836889C10.9588 0.843187 11.8161 1.38132 12.2346 2.22034L12.6268 3.00483C12.784 3.0631 12.9394 3.12628 13.0923 3.19526L13.9224 2.91857C14.8115 2.62188 15.7973 2.84801 16.4663 3.50775C17.1448 4.17669 17.3831 5.1778 17.0815 6.07934L16.8048 6.91266C16.874 7.06415 16.938 7.21755 16.9969 7.37326L17.7814 7.76714C18.6202 8.1855 19.1579 9.04235 19.1648 9.98228C19.1718 10.9352 18.6319 11.8106 17.7814 12.2349L16.9936 12.6287C16.9357 12.7849 16.873 12.9389 16.8048 13.091L17.0815 13.9227V13.9243C17.378 14.8126 17.1523 15.7974 16.494 16.4666C15.8255 17.1459 14.8244 17.3844 13.9224 17.0834L13.0874 16.8051C12.9359 16.8741 12.7826 16.9383 12.6268 16.9972L12.2346 17.7817C11.8161 18.6206 10.9588 19.1578 10.0194 19.1651ZM10.0064 17.4985C10.3198 17.496 10.603 17.3183 10.7437 17.0362L11.2727 15.9783C11.3223 15.8788 11.3914 15.7902 11.4758 15.7178C11.5602 15.6454 11.6583 15.5907 11.7642 15.5568C12.0782 15.4566 12.3831 15.3309 12.6756 15.1792C12.7744 15.1278 12.8825 15.0967 12.9934 15.0877C13.1044 15.0788 13.2161 15.0922 13.3218 15.1271L14.4481 15.5014H14.4497C14.7532 15.6028 15.0829 15.5235 15.3058 15.298C15.5254 15.0747 15.5995 14.749 15.4995 14.45V14.4484L15.1268 13.327C15.092 13.2222 15.0785 13.1115 15.0868 13.0014C15.0952 12.8913 15.1254 12.784 15.1756 12.6857C15.3255 12.3925 15.4499 12.0869 15.5483 11.7726C15.5819 11.6657 15.6366 11.5666 15.7093 11.4813C15.782 11.396 15.8712 11.3262 15.9715 11.2762L17.0359 10.744C17.3222 10.6013 17.5005 10.3127 17.4982 9.9953C17.4959 9.68255 17.3182 9.39876 17.0359 9.25801H17.0343L15.9764 8.72741C15.8772 8.67758 15.7889 8.60843 15.7168 8.52402C15.6447 8.43961 15.5902 8.34165 15.5565 8.23588C15.4557 7.92187 15.3295 7.61697 15.1772 7.32444C15.1256 7.22545 15.0944 7.11711 15.0855 7.00583C15.0765 6.89456 15.09 6.78262 15.1252 6.67666L15.4995 5.552C15.601 5.2487 15.5239 4.91897 15.2977 4.69589C15.0747 4.47605 14.7488 4.40074 14.4497 4.50058H14.4481L13.3267 4.8733C13.2216 4.90826 13.1107 4.92195 13.0003 4.91357C12.8899 4.90519 12.7823 4.8749 12.6838 4.82447C12.3902 4.67392 12.0855 4.54889 11.7707 4.45012C11.6638 4.41659 11.5647 4.36183 11.4794 4.28912C11.3941 4.21641 11.3243 4.12724 11.2743 4.02695L10.7437 2.96577C10.603 2.68357 10.3199 2.50599 10.0064 2.50353C9.68816 2.50105 9.39895 2.67928 9.25609 2.96577L8.72712 4.02207C8.67746 4.12158 8.60839 4.21013 8.52397 4.28253C8.43955 4.35493 8.3415 4.4097 8.23559 4.44361C7.92108 4.5444 7.6155 4.6704 7.32252 4.82284C7.22353 4.87446 7.11519 4.90568 7.00391 4.91462C6.89264 4.92357 6.7807 4.91007 6.67474 4.87492L5.55008 4.50058C5.25099 4.40074 4.92509 4.47542 4.70211 4.69589C4.47583 4.91888 4.3988 5.24866 4.50029 5.552V5.55363L4.873 6.67503C4.90772 6.78017 4.92114 6.89117 4.91248 7.00156C4.90381 7.11194 4.87324 7.21949 4.82255 7.31793C4.67221 7.61052 4.54712 7.91555 4.4482 8.22937C4.41486 8.33574 4.36051 8.43433 4.28838 8.51932C4.21625 8.6043 4.12781 8.67396 4.02829 8.72416L2.96547 9.25801H2.96385C2.68158 9.39879 2.5039 9.68239 2.50161 9.9953C2.49929 10.3127 2.67757 10.6012 2.96385 10.744L4.02178 11.273C4.12128 11.3226 4.20984 11.3917 4.28224 11.4761C4.35463 11.5605 4.4094 11.6586 4.44332 11.7645C4.54407 12.0785 4.67026 12.3834 4.82255 12.6759C4.87395 12.7747 4.90504 12.8828 4.91399 12.9937C4.92293 13.1047 4.90955 13.2164 4.87463 13.3221L4.50029 14.4484V14.45C4.40026 14.7489 4.4744 15.0748 4.69397 15.298C4.91688 15.5244 5.24657 15.6025 5.55008 15.5014L6.67311 15.1271C6.77814 15.0921 6.88909 15.0784 6.99947 15.0868C7.10985 15.0952 7.21746 15.1255 7.31601 15.1759C7.60876 15.3258 7.91366 15.4502 8.22745 15.5486C8.3344 15.5821 8.43349 15.6369 8.51878 15.7096C8.60408 15.7823 8.67383 15.8715 8.72387 15.9718L9.25609 17.0362C9.39895 17.3228 9.68816 17.5009 10.0064 17.4985ZM10.0031 14.1668C7.71186 14.1668 5.83166 12.2931 5.83165 10.0018C5.83163 7.71053 7.71185 5.83194 10.0031 5.83194C12.2944 5.83194 14.1665 7.71053 14.1665 10.0018C14.1665 12.2931 12.2944 14.1668 10.0031 14.1668ZM10.0031 12.5002C11.3937 12.5002 12.4999 11.3924 12.4999 10.0018C12.4999 8.61125 11.3937 7.49859 10.0031 7.49859C8.61258 7.49859 7.49829 8.61125 7.49829 10.0018C7.4983 11.3924 8.61258 12.5002 10.0031 12.5002Z"
          fill="var(--nonactionable-icon-color,#678BFF)"
        />
      </g>
      <defs>
        <clipPath id="clip0_680_543">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(1 0 0 -1 0 20)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  SettingsIcon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_680_543)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0194 19.1651C9.06613 19.1714 8.18989 18.6331 7.76522 17.7817L7.37134 16.9939C7.21613 16.9363 7.06343 16.8731 6.91236 16.8051L6.07741 17.0834C5.1754 17.3845 4.17424 17.1458 3.50583 16.4666C2.84707 15.797 2.62093 14.8113 2.91827 13.9227L3.19659 13.0893C3.1271 12.9372 3.06208 12.7835 3.00291 12.6271L2.21841 12.2349C1.36785 11.8106 0.827994 10.9352 0.834967 9.98228C0.841842 9.04276 1.37855 8.18572 2.21679 7.76714L3.00616 7.37001C3.06403 7.21474 3.12696 7.06199 3.19496 6.91103L2.91827 6.07771C2.61747 5.17655 2.85543 4.17628 3.5335 3.50775C4.20251 2.84814 5.18828 2.62185 6.07741 2.91857L6.91074 3.19526C7.06267 3.12597 7.21675 3.06241 7.37297 3.0032L7.76522 2.22034C8.18989 1.36885 9.06613 0.829426 10.0194 0.836889C10.9588 0.843187 11.8161 1.38132 12.2346 2.22034L12.6268 3.00483C12.784 3.0631 12.9394 3.12628 13.0923 3.19526L13.9224 2.91857C14.8115 2.62188 15.7973 2.84801 16.4663 3.50775C17.1448 4.17669 17.3831 5.1778 17.0815 6.07934L16.8048 6.91266C16.874 7.06415 16.938 7.21755 16.9969 7.37326L17.7814 7.76714C18.6202 8.1855 19.1579 9.04235 19.1648 9.98228C19.1718 10.9352 18.6319 11.8106 17.7814 12.2349L16.9936 12.6287C16.9357 12.7849 16.873 12.9389 16.8048 13.091L17.0815 13.9227V13.9243C17.378 14.8126 17.1523 15.7974 16.494 16.4666C15.8255 17.1459 14.8244 17.3844 13.9224 17.0834L13.0874 16.8051C12.9359 16.8741 12.7826 16.9383 12.6268 16.9972L12.2346 17.7817C11.8161 18.6206 10.9588 19.1578 10.0194 19.1651ZM10.0064 17.4985C10.3198 17.496 10.603 17.3183 10.7437 17.0362L11.2727 15.9783C11.3223 15.8788 11.3914 15.7902 11.4758 15.7178C11.5602 15.6454 11.6583 15.5907 11.7642 15.5568C12.0782 15.4566 12.3831 15.3309 12.6756 15.1792C12.7744 15.1278 12.8825 15.0967 12.9934 15.0877C13.1044 15.0788 13.2161 15.0922 13.3218 15.1271L14.4481 15.5014H14.4497C14.7532 15.6028 15.0829 15.5235 15.3058 15.298C15.5254 15.0747 15.5995 14.749 15.4995 14.45V14.4484L15.1268 13.327C15.092 13.2222 15.0785 13.1115 15.0868 13.0014C15.0952 12.8913 15.1254 12.784 15.1756 12.6857C15.3255 12.3925 15.4499 12.0869 15.5483 11.7726C15.5819 11.6657 15.6366 11.5666 15.7093 11.4813C15.782 11.396 15.8712 11.3262 15.9715 11.2762L17.0359 10.744C17.3222 10.6013 17.5005 10.3127 17.4982 9.9953C17.4959 9.68255 17.3182 9.39876 17.0359 9.25801H17.0343L15.9764 8.72741C15.8772 8.67758 15.7889 8.60843 15.7168 8.52402C15.6447 8.43961 15.5902 8.34165 15.5565 8.23588C15.4557 7.92187 15.3295 7.61697 15.1772 7.32444C15.1256 7.22545 15.0944 7.11711 15.0855 7.00583C15.0765 6.89456 15.09 6.78262 15.1252 6.67666L15.4995 5.552C15.601 5.2487 15.5239 4.91897 15.2977 4.69589C15.0747 4.47605 14.7488 4.40074 14.4497 4.50058H14.4481L13.3267 4.8733C13.2216 4.90826 13.1107 4.92195 13.0003 4.91357C12.8899 4.90519 12.7823 4.8749 12.6838 4.82447C12.3902 4.67392 12.0855 4.54889 11.7707 4.45012C11.6638 4.41659 11.5647 4.36183 11.4794 4.28912C11.3941 4.21641 11.3243 4.12724 11.2743 4.02695L10.7437 2.96577C10.603 2.68357 10.3199 2.50599 10.0064 2.50353C9.68816 2.50105 9.39895 2.67928 9.25609 2.96577L8.72712 4.02207C8.67746 4.12158 8.60839 4.21013 8.52397 4.28253C8.43955 4.35493 8.3415 4.4097 8.23559 4.44361C7.92108 4.5444 7.6155 4.6704 7.32252 4.82284C7.22353 4.87446 7.11519 4.90568 7.00391 4.91462C6.89264 4.92357 6.7807 4.91007 6.67474 4.87492L5.55008 4.50058C5.25099 4.40074 4.92509 4.47542 4.70211 4.69589C4.47583 4.91888 4.3988 5.24866 4.50029 5.552V5.55363L4.873 6.67503C4.90772 6.78017 4.92114 6.89117 4.91248 7.00156C4.90381 7.11194 4.87324 7.21949 4.82255 7.31793C4.67221 7.61052 4.54712 7.91555 4.4482 8.22937C4.41486 8.33574 4.36051 8.43433 4.28838 8.51932C4.21625 8.6043 4.12781 8.67396 4.02829 8.72416L2.96547 9.25801H2.96385C2.68158 9.39879 2.5039 9.68239 2.50161 9.9953C2.49929 10.3127 2.67757 10.6012 2.96385 10.744L4.02178 11.273C4.12128 11.3226 4.20984 11.3917 4.28224 11.4761C4.35463 11.5605 4.4094 11.6586 4.44332 11.7645C4.54407 12.0785 4.67026 12.3834 4.82255 12.6759C4.87395 12.7747 4.90504 12.8828 4.91399 12.9937C4.92293 13.1047 4.90955 13.2164 4.87463 13.3221L4.50029 14.4484V14.45C4.40026 14.7489 4.4744 15.0748 4.69397 15.298C4.91688 15.5244 5.24657 15.6025 5.55008 15.5014L6.67311 15.1271C6.77814 15.0921 6.88909 15.0784 6.99947 15.0868C7.10985 15.0952 7.21746 15.1255 7.31601 15.1759C7.60876 15.3258 7.91366 15.4502 8.22745 15.5486C8.3344 15.5821 8.43349 15.6369 8.51878 15.7096C8.60408 15.7823 8.67383 15.8715 8.72387 15.9718L9.25609 17.0362C9.39895 17.3228 9.68816 17.5009 10.0064 17.4985ZM10.0031 14.1668C7.71186 14.1668 5.83166 12.2931 5.83165 10.0018C5.83163 7.71053 7.71185 5.83194 10.0031 5.83194C12.2944 5.83194 14.1665 7.71053 14.1665 10.0018C14.1665 12.2931 12.2944 14.1668 10.0031 14.1668ZM10.0031 12.5002C11.3937 12.5002 12.4999 11.3924 12.4999 10.0018C12.4999 8.61125 11.3937 7.49859 10.0031 7.49859C8.61258 7.49859 7.49829 8.61125 7.49829 10.0018C7.4983 11.3924 8.61258 12.5002 10.0031 12.5002Z"
          fill="var(--nonactionable-icon-color,#E8EAEE)"
        />
      </g>
      <defs>
        <clipPath id="clip0_680_543">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(1 0 0 -1 0 20)"
          />
        </clipPath>
      </defs>
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="16"
    //   height="16"
    //   viewBox="0 0 20 20"
    //   style={{
    //     borderRadius: "50%",
    //     // boxShadow: "0 0 5px #d9e5ed",
    //   }}
    // >
    //   <g clipPath="url(#clip0)">
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M10.0194 19.1651C9.06613 19.1714 8.18989 18.6331 7.76522 17.7817L7.37134 16.9939C7.21613 16.9363 7.06343 16.8731 6.91236 16.8051L6.07741 17.0834C5.1754 17.3845 4.17424 17.1458 3.50583 16.4666C2.84707 15.797 2.62093 14.8113 2.91827 13.9227L3.19659 13.0893C3.1271 12.9372 3.06208 12.7835 3.00291 12.6271L2.21841 12.2349C1.36785 11.8106 0.827994 10.9352 0.834967 9.98228C0.841842 9.04276 1.37855 8.18572 2.21679 7.76714L3.00616 7.37001C3.06403 7.21474 3.12696 7.06199 3.19496 6.91103L2.91827 6.07771C2.61747 5.17655 2.85543 4.17628 3.5335 3.50775C4.20251 2.84814 5.18828 2.62185 6.07741 2.91857L6.91074 3.19526C7.06267 3.12597 7.21675 3.06241 7.37297 3.0032L7.76522 2.22034C8.18989 1.36885 9.06613 0.829426 10.0194 0.836889C10.9588 0.843187 11.8161 1.38132 12.2346 2.22034L12.6268 3.00483C12.784 3.0631 12.9394 3.12628 13.0923 3.19526L13.9224 2.91857C14.8115 2.62188 15.7973 2.84801 16.4663 3.50775C17.1448 4.17669 17.3831 5.1778 17.0815 6.07934L16.8048 6.91266C16.874 7.06415 16.938 7.21755 16.9969 7.37326L17.7814 7.76714C18.6202 8.1855 19.1579 9.04235 19.1648 9.98228C19.1718 10.9352 18.6319 11.8106 17.7814 12.2349L16.9936 12.6287C16.9357 12.7849 16.873 12.9389 16.8048 13.091L17.0815 13.9227V13.9243C17.378 14.8126 17.1523 15.7974 16.494 16.4666C15.8255 17.1459 14.8244 17.3844 13.9224 17.0834L13.0874 16.8051C12.9359 16.8741 12.7826 16.9383 12.6268 16.9972L12.2346 17.7817C11.8161 18.6206 10.9588 19.1578 10.0194 19.1651ZM10.0031 14.1668C7.71186 14.1668 5.83166 12.2931 5.83165 10.0018C5.83163 7.71053 7.71185 5.83194 10.0031 5.83194C12.2944 5.83194 14.1665 7.71053 14.1665 10.0018C14.1665 12.2931 12.2944 14.1668 10.0031 14.1668Z"
    //       fill="currentColor"
    //     />
    //   </g>
    // </svg>
  ),
  FollowersIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
    >
      <g fill="var(--nonactionable-icon-color,#185edf)">
        <path d="M8.963 16.563H2.857a.7.7 0 0 1-.668-.917 5.415 5.415 0 0 1 5.145-3.663 5.249 5.249 0 0 1 3.018.946.7.7 0 1 0 .8-1.151 6.669 6.669 0 0 0-1.4-.747 3.573 3.573 0 0 0 1.162-2.357 5.284 5.284 0 0 1 6.7-.547.7.7 0 1 0 .8-1.151 6.669 6.669 0 0 0-1.4-.747 3.579 3.579 0 1 0-4.82-.008q-.147.057-.292.12a6.663 6.663 0 0 0-1.236.71 3.579 3.579 0 1 0-5.742 3.968 6.75 6.75 0 0 0-4.076 4.2 2.106 2.106 0 0 0 2 2.751h6.115a.7.7 0 0 0 0-1.4ZM14.613 1.4a2.176 2.176 0 1 1-2.179 2.179A2.178 2.178 0 0 1 14.613 1.4Zm-7.264 4.8a2.176 2.176 0 1 1-2.176 2.183A2.178 2.178 0 0 1 7.349 6.2Z" />
        <path d="M18.425 11.4a.7.7 0 0 0-.979.162l-3.459 4.832a.4.4 0 0 1-.577.03l-2.24-2.15a.702.702 0 0 0-.972 1.012l2.242 2.15a1.81 1.81 0 0 0 1.245.5h.119a1.809 1.809 0 0 0 1.287-.67l.024-.031 3.473-4.852a.7.7 0 0 0-.163-.983Z" />
      </g>
    </svg>
  ),

  verifiedIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <g transform="translate(2,8)">
        <path
          d="M8.545 1.855a2.673 2.673 0 0 1 3.6 3.6 2.671 2.671 0 0 1 0 5.087 2.673 2.673 0 0 1-3.6 3.6 2.664 2.664 0 0 1-5.077 0 2.676 2.676 0 0 1-3.613-3.6 2.664 2.664 0 0 1 0-5.077 2.677 2.677 0 0 1 3.6-3.613 2.673 2.673 0 0 1 5.089 0Z"
          fill="#27c2ff" //"var(--nonactionable-icon-color,#27c2ff)"
        />
        <path
          transform="translate(-1.5,0)"
          d="m6.637 11.073-2.345-2.344a.501.501 0 1 1 .706-.712l1.637 1.637 4.361-4.353a.503.503 0 1 1 .708.714Z"
          fill="#fff"
        />
      </g>
    </svg>
  ),
  clock_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      className="clock-icon"
      style={{ color: "var(--nonactionable-icon-color,#3b5175)" }} // nonactionable-icon-color
    >
      <path d="M9 2.25a6.75 6.75 0 1 1-6.75 6.75A6.75 6.75 0 0 1 9 2.25m0-1.5A8.25 8.25 0 1 0 17.25 9 8.25 8.25 0 0 0 9 .75Z" />
      <path d="M12.75 12a.75.75 0 0 1-.375-.112L8.25 9.413V5.25a.75.75 0 0 1 1.5 0V8.75l3.375 2.025A.75.75 0 0 1 12.75 12Z" />
    </svg>
  ),
  trends_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
      <path data-name="Path 13929" d="M0 0h18v18H0Z" fill="none" />
      <path
        data-name="Path 13930"
        d="m12 4.5 1.718 1.717-3.66 3.66-3-3L1.5 12.443 2.558 13.5l4.5-4.5 3 3 4.725-4.717L16.5 9V4.5Z"
        fill="#185edf" //"var(--actionable-icon-color,#185edf)" //"#185edf"
      />
    </svg>
  ),
  close_cross_icon: (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 48 48"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect
          id="Rectangle_143618"
          data-name="Rectangle 143618"
          width="22"
          height="22"
          fill="none"
        />
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <path
          id="Path_70920"
          data-name="Path 70920"
          d="M26.8,24,37.4,13.5a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L24,21.2,13.4,10.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7L21.2,24,10.6,34.5a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L24,26.8,34.6,37.4a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7Z"
          fill="var(--nonactionable-icon-color,#f5f6f8)" //"#f5f6f8"
        />
      </g>
    </svg>
  ),
  delete_bin_icon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: "var(--nonactionable-icon-color,#FF5D48)" }}
    >
      <path
        d="M4.875 7.62L5.125 15.187C5.146 15.835 5.419 16.449 5.886 16.899C6.352 17.349 6.976 17.6 7.625 17.598H12.375C13.023 17.6 13.646 17.35 14.113 16.9C14.579 16.451 14.853 15.837 14.875 15.189L15.125 7.62C15.131 7.454 15.07 7.293 14.957 7.172C14.843 7.051 14.686 6.98 14.521 6.974C14.355 6.969 14.194 7.03 14.073 7.143C13.952 7.256 13.88 7.413 13.875 7.579L13.625 15.148C13.613 15.471 13.475 15.776 13.242 16.001C13.009 16.225 12.698 16.35 12.375 16.349H7.625C7.301 16.35 6.99 16.224 6.757 16C6.524 15.775 6.387 15.469 6.375 15.145L6.125 7.579C6.12 7.413 6.048 7.256 5.927 7.143C5.806 7.03 5.645 6.969 5.479 6.974C5.314 6.98 5.157 7.051 5.044 7.172C4.93 7.293 4.87 7.454 4.875 7.62ZM4.048 5.102C4.048 5.268 4.114 5.427 4.231 5.544C4.348 5.661 4.507 5.727 4.673 5.727H15.326C15.492 5.727 15.651 5.661 15.768 5.544C15.885 5.427 15.951 5.268 15.951 5.102C15.951 4.936 15.885 4.777 15.768 4.66C15.651 4.543 15.492 4.477 15.326 4.477H13.389C13.191 4.478 12.999 4.404 12.853 4.272C12.705 4.139 12.613 3.956 12.593 3.759C12.547 3.297 12.331 2.869 11.986 2.558C11.641 2.246 11.193 2.074 10.728 2.076H9.272C8.807 2.074 8.359 2.246 8.014 2.558C7.669 2.869 7.453 3.297 7.407 3.759C7.387 3.956 7.295 4.139 7.148 4.272C7.001 4.404 6.809 4.478 6.611 4.477H4.674C4.508 4.477 4.349 4.543 4.232 4.66C4.115 4.777 4.049 4.936 4.049 5.102H4.048ZM11.508 4.477H8.491C8.573 4.289 8.627 4.09 8.65 3.887C8.666 3.733 8.738 3.59 8.852 3.486C8.967 3.382 9.116 3.325 9.271 3.324H10.727C10.882 3.325 11.032 3.382 11.146 3.486C11.261 3.59 11.333 3.733 11.349 3.887C11.373 4.09 11.426 4.289 11.508 4.477ZM10.879 13.946V8.624C10.879 8.459 10.945 8.3 11.062 8.182C11.179 8.065 11.338 7.999 11.504 7.999C11.67 7.999 11.829 8.065 11.946 8.182C12.063 8.3 12.129 8.459 12.129 8.624V13.949C12.129 14.115 12.063 14.274 11.946 14.391C11.829 14.508 11.67 14.574 11.504 14.574C11.338 14.574 11.179 14.508 11.062 14.391C10.945 14.274 10.879 14.115 10.879 13.949V13.946ZM7.87 13.946V8.624C7.87 8.459 7.936 8.3 8.053 8.182C8.17 8.065 8.329 7.999 8.495 7.999C8.661 7.999 8.82 8.065 8.937 8.182C9.054 8.3 9.12 8.459 9.12 8.624V13.949C9.12 14.115 9.054 14.274 8.937 14.391C8.82 14.508 8.661 14.574 8.495 14.574C8.329 14.574 8.17 14.508 8.053 14.391C7.936 14.274 7.87 14.115 7.87 13.949V13.946Z"
        fill="#FF5D48" //"var(--nonactionable-icon-color,#FF5D48)"
      />
    </svg>
  ),
  country_globe_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19.999"
      data-name="Group 38679"
    >
      <defs>
        <clipPath id="a">
          <path
            fill="#3b5175"
            d="M0 0h20v19.999H0z"
            data-name="Rectangle 141633"
          />
        </clipPath>
      </defs>
      <g clip-path="url(#a)" data-name="Group 38678">
        <path
          fill="var(--nonactionable-icon-color,#3b5175)" //"#3b5175"
          d="M20 9.499v1.016c-.01.057-.025.113-.029.17a9.527 9.527 0 0 1-2.063 5.4 9.694 9.694 0 0 1-9.676 3.745 9.943 9.943 0 0 1-8.024-7.819 9.793 9.793 0 0 1 .275-5.052A9.91 9.91 0 0 1 3.9 2.099 9.75 9.75 0 0 1 8.356.153c.351-.054.705-.102 1.058-.154h1.172c.4.057.813.1 1.214.175a9.848 9.848 0 0 1 6.564 4.382 9.683 9.683 0 0 1 1.476 3.728c.07.4.107.81.159 1.216m-5.7-.214h4.236a8.449 8.449 0 0 0-1.206-3.706A13 13 0 0 1 13.9 6.761l.4 2.525M2.675 14.435a13.078 13.078 0 0 1 3.433-1.178l-.4-2.526H1.472a8.471 8.471 0 0 0 1.2 3.7m3.434-7.672a13.081 13.081 0 0 1-3.432-1.177 8.464 8.464 0 0 0-1.2 3.7h4.233l.4-2.527m7.794 6.5a13.113 13.113 0 0 1 3.433 1.175 8.476 8.476 0 0 0 1.2-3.7H14.3l-.4 2.525m-6.752-3.97h5.678a11.043 11.043 0 0 0-.385-2.286c-.075.007-.138.015-.2.018-.942.036-1.883.092-2.826.1-.571 0-1.142-.063-1.713-.107-.107-.008-.151.016-.171.124-.035.185-.1.365-.128.551-.089.524-.168 1.05-.254 1.6m5.678 1.447H7.136l.387 2.253c.869-.042 1.681-.111 2.492-.111s1.618.07 2.431.11a11.082 11.082 0 0 0 .38-2.252m3.658-6.32a8.477 8.477 0 0 0-4.916-2.813 20.215 20.215 0 0 1 1.874 3.787 11.878 11.878 0 0 0 3.042-.979m-9.916.981a20.3 20.3 0 0 1 1.866-3.781 8.473 8.473 0 0 0-4.912 2.806 12.031 12.031 0 0 0 3.046.98m5 13.016a8.466 8.466 0 0 0 4.912-2.8 11.751 11.751 0 0 0-3.045-.978 20.263 20.263 0 0 1-1.867 3.783m-8.05-2.8a8.486 8.486 0 0 0 4.914 2.806 20.306 20.306 0 0 1-1.87-3.785 11.911 11.911 0 0 0-3.044.979M10 1.908a17.229 17.229 0 0 0-1.968 3.677 16.2 16.2 0 0 0 3.931.01A16.51 16.51 0 0 0 10 1.908m-1.979 12.5A16.933 16.933 0 0 0 10 18.111a17.3 17.3 0 0 0 1.978-3.7 18.724 18.724 0 0 0-3.96 0"
          data-name="Path 47787"
        />
      </g>
    </svg>
  ),
  country_globe_icon_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19.999"
      data-name="Group 38679"
    >
      <defs>
        <clipPath id="a">
          <path
            fill="#3b5175"
            d="M0 0h20v19.999H0z"
            data-name="Rectangle 141633"
          />
        </clipPath>
      </defs>
      <g clip-path="url(#a)" data-name="Group 38678">
        <path
          fill="var(--nonactionable-icon-color,#3b5175)" //"#3b5175"
          d="M20 9.499v1.016c-.01.057-.025.113-.029.17a9.527 9.527 0 0 1-2.063 5.4 9.694 9.694 0 0 1-9.676 3.745 9.943 9.943 0 0 1-8.024-7.819 9.793 9.793 0 0 1 .275-5.052A9.91 9.91 0 0 1 3.9 2.099 9.75 9.75 0 0 1 8.356.153c.351-.054.705-.102 1.058-.154h1.172c.4.057.813.1 1.214.175a9.848 9.848 0 0 1 6.564 4.382 9.683 9.683 0 0 1 1.476 3.728c.07.4.107.81.159 1.216m-5.7-.214h4.236a8.449 8.449 0 0 0-1.206-3.706A13 13 0 0 1 13.9 6.761l.4 2.525M2.675 14.435a13.078 13.078 0 0 1 3.433-1.178l-.4-2.526H1.472a8.471 8.471 0 0 0 1.2 3.7m3.434-7.672a13.081 13.081 0 0 1-3.432-1.177 8.464 8.464 0 0 0-1.2 3.7h4.233l.4-2.527m7.794 6.5a13.113 13.113 0 0 1 3.433 1.175 8.476 8.476 0 0 0 1.2-3.7H14.3l-.4 2.525m-6.752-3.97h5.678a11.043 11.043 0 0 0-.385-2.286c-.075.007-.138.015-.2.018-.942.036-1.883.092-2.826.1-.571 0-1.142-.063-1.713-.107-.107-.008-.151.016-.171.124-.035.185-.1.365-.128.551-.089.524-.168 1.05-.254 1.6m5.678 1.447H7.136l.387 2.253c.869-.042 1.681-.111 2.492-.111s1.618.07 2.431.11a11.082 11.082 0 0 0 .38-2.252m3.658-6.32a8.477 8.477 0 0 0-4.916-2.813 20.215 20.215 0 0 1 1.874 3.787 11.878 11.878 0 0 0 3.042-.979m-9.916.981a20.3 20.3 0 0 1 1.866-3.781 8.473 8.473 0 0 0-4.912 2.806 12.031 12.031 0 0 0 3.046.98m5 13.016a8.466 8.466 0 0 0 4.912-2.8 11.751 11.751 0 0 0-3.045-.978 20.263 20.263 0 0 1-1.867 3.783m-8.05-2.8a8.486 8.486 0 0 0 4.914 2.806 20.306 20.306 0 0 1-1.87-3.785 11.911 11.911 0 0 0-3.044.979M10 1.908a17.229 17.229 0 0 0-1.968 3.677 16.2 16.2 0 0 0 3.931.01A16.51 16.51 0 0 0 10 1.908m-1.979 12.5A16.933 16.933 0 0 0 10 18.111a17.3 17.3 0 0 0 1.978-3.7 18.724 18.724 0 0 0-3.96 0"
          data-name="Path 47787"
        />
      </g>
    </svg>
  ),
  language_icon: (
    <svg
      data-name="Group 38682"
      xmlns="http://www.w3.org/2000/svg"
      width="20.001"
      height="20"
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 141634"
            fill="#3b5175"
            d="M0 0h20.001v20H0z"
          />
        </clipPath>
      </defs>
      <g
        data-name="Group 38681"
        clip-path="url(#a)"
        fill="var(--nonactionable-icon-color,#3b5175)"
      >
        {/* "#3b5175" */}
        <path
          data-name="Path 47788"
          d="M1.564-.001h6.445c.036.012.072.026.109.034A1.618 1.618 0 0 1 9.4 1.105a8.029 8.029 0 0 1 .242 1.317c.057.371.1.745.144 1.133h8.346a1.7 1.7 0 0 1 1.513.73 4.557 4.557 0 0 1 .355.832v13.32a3.744 3.744 0 0 1-.178.553 1.734 1.734 0 0 1-1.669 1.009H8.76a1.719 1.719 0 0 1-1.724-1.211 8.49 8.49 0 0 1-.2-1.23c-.051-.365-.093-.732-.141-1.113h-.224c-1.53 0-3.059.009-4.589-.008a2.185 2.185 0 0 1-.867-.176A1.688 1.688 0 0 1 0 14.618c-.006-1.133 0-2.265 0-3.4V1.866A1.7 1.7 0 0 1 .732.352a4.548 4.548 0 0 1 .832-.353m7.378 18.828h9.165c.509 0 .721-.213.721-.724V5.451c0-.511-.212-.724-.721-.724H9.946c0 .054 0 .087.009.119l.508 4.085.84 6.757a.74.74 0 0 1-.186.627c-.285.321-.563.649-.844.974l-1.33 1.54m1.125-3.555-.061-.484-.835-6.741L8.4 1.815a.634.634 0 0 0-.721-.643H1.894c-.509 0-.721.213-.721.724v12.655c0 .51.213.721.724.721h8.17Zm-1.991 2.762 1.361-1.576H7.883l.194 1.576"
        />
        <path
          data-name="Path 47789"
          d="m14.696 13.424-1.342 1.09a.61.61 0 0 1-.541.158.562.562 0 0 1-.446-.438.569.569 0 0 1 .221-.605c.372-.305.746-.608 1.119-.913.055-.045.106-.094.159-.142-.183-.262-.366-.513-.538-.772a6.613 6.613 0 0 1-.785-1.649.184.184 0 0 0-.2-.158.576.576 0 0 1-.582-.584.585.585 0 0 1 .606-.577c.5-.005 1 0 1.5 0h.232v-.557a.586.586 0 1 1 1.17 0v.556H16.966a.593.593 0 0 1 .645.564.6.6 0 0 1-.6.611.207.207 0 0 0-.153.1 7.551 7.551 0 0 1-1.364 2.466c.246.208.485.413.729.614.186.153.38.3.565.45a.583.583 0 0 1 .113.832.575.575 0 0 1-.835.085c-.39-.3-.768-.623-1.151-.936-.075-.061-.148-.123-.224-.187m-.962-3.421a5.924 5.924 0 0 0 .956 1.7 5.918 5.918 0 0 0 .949-1.7Z"
        />
        <path
          data-name="Path 47790"
          d="M6.123 8.83H4.506l-.325 1.62c-.019.1-.036.192-.064.285a.583.583 0 0 1-.677.42.589.589 0 0 1-.458-.69c.082-.441.174-.879.263-1.319l.894-4.452a.611.611 0 0 1 .68-.557h1a.61.61 0 0 1 .677.561q.577 2.866 1.149 5.733a.587.587 0 1 1-1.15.227c-.124-.6-.243-1.209-.366-1.827m-.916-3.514L4.75 7.643h1.142l-.466-2.326Z"
        />
      </g>
    </svg>
  ),
  replace_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 0 24 24"
      width="20px"
      fill="var(--nonactionable-icon-color,#000000)"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z" />
    </svg>
  ),
  replace_icon_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 0 24 24"
      width="20px"
      fill="var(--nonactionable-icon-color,#fff)"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z" />
    </svg>
  ),
  edit_filter_icon_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--nonactionable-icon-color,#fff)"
    >
      <path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-308 198-252H282l198 252Zm0 0Z" />
    </svg>
  ),
  edit_filter_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--nonactionable-icon-color,#3b5175)"
    >
      <path d="M440-160q-17 0-28.5-11.5T400-200v-240L168-736q-15-20-4.5-42t36.5-22h560q26 0 36.5 22t-4.5 42L560-440v240q0 17-11.5 28.5T520-160h-80Zm40-308 198-252H282l198 252Zm0 0Z" />
    </svg>
  ),
  personalization_icon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.2487 13.3333C6.70703 13.3333 7.08203 13.7083 7.08203 14.1667C7.08203 15.0833 6.33203 15.8333 5.41536 15.8333C5.2737 15.8333 5.14036 15.8167 4.9987 15.7917C5.25703 15.3333 5.41536 14.7833 5.41536 14.1667C5.41536 13.7083 5.79036 13.3333 6.2487 13.3333ZM15.9737 2.5C15.757 2.5 15.5487 2.58333 15.382 2.74167L7.91536 10.2083L10.207 12.5L17.6737 5.03333C17.9987 4.70833 17.9987 4.18333 17.6737 3.85833L16.557 2.74167C16.3904 2.575 16.182 2.5 15.9737 2.5ZM6.2487 11.6667C4.86536 11.6667 3.7487 12.7833 3.7487 14.1667C3.7487 15.2583 2.78203 15.8333 2.08203 15.8333C2.8487 16.85 4.15703 17.5 5.41536 17.5C7.25703 17.5 8.7487 16.0083 8.7487 14.1667C8.7487 12.7833 7.63203 11.6667 6.2487 11.6667Z"
        fill="var(--nonactionable-icon-color,#fff)"
      />
    </svg>
  ),
  sort_by_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <path style={{ fill: "none" }} d="M0 0h24v24H0z" />
      <path
        d="M4.149 16.594V4.149H0L5.186 0l5.186 4.149H6.223v12.445Zm4.149 0V14.52h8.3v2.074Zm0-4.149v-2.073h6.222v2.074ZM8.3 8.3V6.223h4.149V8.3Z"
        transform="translate(4 4)"
        style={{ fill: "var(--nonactionable-icon-color,#3b5175)" }}
      />
    </svg>
  ),
  sort_by_icon_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <path style={{ fill: "none" }} d="M0 0h24v24H0z" />
      <path
        d="M4.149 16.594V4.149H0L5.186 0l5.186 4.149H6.223v12.445Zm4.149 0V14.52h8.3v2.074Zm0-4.149v-2.073h6.222v2.074ZM8.3 8.3V6.223h4.149V8.3Z"
        transform="translate(4 4)"
        style={{ fill: "var(--nonactionable-icon-color,#fff)" }}
      />
    </svg>
  ),
  accordion_arrow: (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.168" height="6.645">
      <path
        fill="none"
        stroke="var(--nonactionable-icon-color,#3b5175)"
        stroke-width="1.5"
        d="M10.642 6.114 5.588 1.06.534 6.114"
        data-name="Path 16218"
      />
    </svg>
  ),
  accordion_arrow_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.168" height="6.645">
      <path
        fill="none"
        stroke="var(--nonactionable-icon-color,#fff)"
        stroke-width="1.5"
        d="M10.642 6.114 5.588 1.06.534 6.114"
        data-name="Path 16218"
      />
    </svg>
  ),
  info_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
      <path
        d="M7 0a7 7 0 1 0 7 7 7 7 0 0 0-7-7Zm1.457 10.849q-.54.213-.862.325a2.275 2.275 0 0 1-.748.112 1.49 1.49 0 0 1-1.017-.319 1.031 1.031 0 0 1-.362-.81 2.942 2.942 0 0 1 .027-.391c.018-.133.047-.282.087-.45l.451-1.593c.04-.153.074-.3.1-.433a1.921 1.921 0 0 0 .04-.375.578.578 0 0 0-.126-.425.714.714 0 0 0-.482-.119 1.264 1.264 0 0 0-.359.053c-.121.037-.227.071-.313.1l.119-.491q.443-.18.847-.309a2.5 2.5 0 0 1 .766-.124 1.463 1.463 0 0 1 1 .314 1.043 1.043 0 0 1 .352.815q0 .1-.024.366a2.447 2.447 0 0 1-.09.481l-.446 1.587a4.787 4.787 0 0 0-.1.436 2.306 2.306 0 0 0-.043.371.533.533 0 0 0 .142.431.793.793 0 0 0 .49.115 1.422 1.422 0 0 0 .371-.057 2.109 2.109 0 0 0 .3-.1ZM8.377 4.4a1.071 1.071 0 0 1-.756.292 1.082 1.082 0 0 1-.758-.292.931.931 0 0 1-.315-.7.94.94 0 0 1 .316-.709 1.074 1.074 0 0 1 .759-.295 1.062 1.062 0 0 1 .756.295.955.955 0 0 1 0 1.416Z"
        fill="var(--nonactionable-icon-color,#869dad)"
      />
    </svg>
  ),
  play_icon: (
    <svg
      width="16"
      height="19"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2.5L6 19.5"
        stroke="var(--nonactionable-icon-color,#C3CBD7"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M15 2.5L15 19.5"
        stroke="var(--nonactionable-icon-color,#C3CBD7)"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  ),
  pause_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      viewBox="0 0 21 22"
    >
      <path
        id="Polygon_79"
        data-name="Polygon 79"
        d="M9.766,3.015a2,2,0,0,1,3.468,0L21.277,17a2,2,0,0,1-1.734,3H3.457a2,2,0,0,1-1.734-3Z"
        transform="rotate(90 10.5 11)"
        fill="var(--nonactionable-icon-color,#fff)"
      />
    </svg>
  ),
  customize_brush_icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M6.2487 13.3333C6.70703 13.3333 7.08203 13.7083 7.08203 14.1667C7.08203 15.0833 6.33203 15.8333 5.41536 15.8333C5.2737 15.8333 5.14036 15.8167 4.9987 15.7917C5.25703 15.3333 5.41536 14.7833 5.41536 14.1667C5.41536 13.7083 5.79036 13.3333 6.2487 13.3333ZM15.9737 2.5C15.757 2.5 15.5487 2.58333 15.382 2.74167L7.91536 10.2083L10.207 12.5L17.6737 5.03333C17.9987 4.70833 17.9987 4.18333 17.6737 3.85833L16.557 2.74167C16.3904 2.575 16.182 2.5 15.9737 2.5ZM6.2487 11.6667C4.86536 11.6667 3.7487 12.7833 3.7487 14.1667C3.7487 15.2583 2.78203 15.8333 2.08203 15.8333C2.8487 16.85 4.15703 17.5 5.41536 17.5C7.25703 17.5 8.7487 16.0083 8.7487 14.1667C8.7487 12.7833 7.63203 11.6667 6.2487 11.6667Z"
          fill="var(--nonactionable-icon-color,#fff)"
        />
      </g>
    </svg>
  ),
  alert_notification_icon: (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16667 12.3327H8.83333V13.9993H7.16667V12.3327ZM7.16667 5.66602H8.83333V10.666H7.16667V5.66602ZM13.8333 2.33268H10.35C10 1.36602 9.08333 0.666016 8 0.666016C6.91667 0.666016 6 1.36602 5.65 2.33268H2.16667C2.05 2.33268 1.94167 2.34102 1.83333 2.36602C1.50833 2.43268 1.21667 2.59935 0.991667 2.82435C0.841667 2.97435 0.716667 3.15768 0.633333 3.35768C0.55 3.54935 0.5 3.76602 0.5 3.99935V15.666C0.5 15.891 0.55 16.116 0.633333 16.316C0.716667 16.516 0.841667 16.691 0.991667 16.8493C1.21667 17.0743 1.50833 17.241 1.83333 17.3077C1.94167 17.3243 2.05 17.3327 2.16667 17.3327H13.8333C14.75 17.3327 15.5 16.5827 15.5 15.666V3.99935C15.5 3.08268 14.75 2.33268 13.8333 2.33268ZM8 2.12435C8.34167 2.12435 8.625 2.40768 8.625 2.74935C8.625 3.09102 8.34167 3.37435 8 3.37435C7.65833 3.37435 7.375 3.09102 7.375 2.74935C7.375 2.40768 7.65833 2.12435 8 2.12435ZM13.8333 15.666H2.16667V3.99935H13.8333V15.666Z"
        fill="#F1B315"
      />
    </svg>
  ),
  close_cross_icon_black: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z"
        fill="black"
      />
    </svg>
  ),
  duration_icon_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      data-name="Component 182 – 4"
    >
      <defs>
        <clipPath id="a">
          <path
            fill="var(--nonactionable-icon-color,#fff)"
            stroke="#707070"
            d="M286 11h18v18h-18z"
            data-name="Rectangle 14933"
          />
        </clipPath>
      </defs>
      <g
        clip-path="url(#a)"
        data-name="Mask Group 1053"
        transform="translate(-286 -11)"
      >
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              fill="none"
              d="M286 11h18v18h-18z"
              data-name="Rectangle 14929"
            />
          </g>
          <g
            fill="var(--nonactionable-icon-color,#fff)"
            data-name="icons Q2"
            transform="translate(286 11)"
          >
            <path
              d="M16.5 3h-3.375V1.537a.787.787 0 0 0-.638-.787.75.75 0 0 0-.862.75V3h-5.25V1.537A.788.788 0 0 0 5.737.75a.75.75 0 0 0-.862.75V3H1.5a.75.75 0 0 0-.75.75v12a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-12A.75.75 0 0 0 16.5 3Zm-.75 12H2.25V7.5h13.5Zm0-9H2.25V4.5h13.5Z"
              data-name="Path 20424"
            />
            <rect
              width="3"
              height="3"
              data-name="Rectangle 14930"
              rx=".75"
              transform="translate(3 9)"
            />
            <rect
              width="3"
              height="3"
              data-name="Rectangle 14931"
              rx=".75"
              transform="translate(12 9)"
            />
            <rect
              width="3"
              height="3"
              data-name="Rectangle 14932"
              rx=".75"
              transform="translate(7.5 9)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  duration_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      data-name="Component 182 – 4"
    >
      <defs>
        <clipPath id="a">
          <path
            fill="var(--nonactionable-icon-color,#fff)"
            stroke="#707070"
            d="M286 11h18v18h-18z"
            data-name="Rectangle 14933"
          />
        </clipPath>
      </defs>
      <g
        clip-path="url(#a)"
        data-name="Mask Group 1053"
        transform="translate(-286 -11)"
      >
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              fill="none"
              d="M286 11h18v18h-18z"
              data-name="Rectangle 14929"
            />
          </g>
          <g
            fill="var(--nonactionable-icon-color,#fff)"
            data-name="icons Q2"
            transform="translate(286 11)"
          >
            <path
              d="M16.5 3h-3.375V1.537a.787.787 0 0 0-.638-.787.75.75 0 0 0-.862.75V3h-5.25V1.537A.788.788 0 0 0 5.737.75a.75.75 0 0 0-.862.75V3H1.5a.75.75 0 0 0-.75.75v12a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-12A.75.75 0 0 0 16.5 3Zm-.75 12H2.25V7.5h13.5Zm0-9H2.25V4.5h13.5Z"
              data-name="Path 20424"
            />
            <rect
              width="3"
              height="3"
              data-name="Rectangle 14930"
              rx=".75"
              transform="translate(3 9)"
            />
            <rect
              width="3"
              height="3"
              data-name="Rectangle 14931"
              rx=".75"
              transform="translate(12 9)"
            />
            <rect
              width="3"
              height="3"
              data-name="Rectangle 14932"
              rx=".75"
              transform="translate(7.5 9)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  CategoryFilterIcon: (
    <svg
      id="Category"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect
          id="Rectangle_143314"
          data-name="Rectangle 143314"
          width="18"
          height="18"
          fill="none"
        />
      </g>
      <g id="Q3_icons" data-name="Q3 icons" transform="translate(1.5 0.75)">
        <path
          id="Path_62012"
          data-name="Path 62012"
          d="M12.25,12.5h6a.75.75,0,0,0,.75-.75v-3A.75.75,0,0,0,18.25,8h-6a.75.75,0,0,0-.75.75V9.5h-3v-3h2.25a.75.75,0,0,0,.75-.75v-3A.75.75,0,0,0,10.75,2h-6A.75.75,0,0,0,4,2.75v3a.75.75,0,0,0,.75.75H7v9.75a.75.75,0,0,0,.75.75H11.5v.75a.75.75,0,0,0,.75.75h6a.75.75,0,0,0,.75-.75v-3a.75.75,0,0,0-.75-.75h-6a.75.75,0,0,0-.75.75v.75h-3V11h3v.75A.75.75,0,0,0,12.25,12.5Zm.75-3h4.5V11H13Zm-7.5-6H10V5H5.5Zm7.5,12h4.5V17H13Z"
          transform="translate(-4 -2)"
          fill="var(--nonactionable-icon-color,#f5f6f8)"
        />
      </g>
    </svg>
  ),
  LocationFilterIcon: (
    <svg
      id="Location"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect
          id="Rectangle_143313"
          data-name="Rectangle 143313"
          width="18"
          height="18"
          fill="none"
        />
      </g>
      <g id="icons_Q2" data-name="icons Q2" transform="translate(2.625 0.75)">
        <path
          id="Path_62010"
          data-name="Path 62010"
          d="M19.625,11.5A1.125,1.125,0,1,1,18.5,12.625,1.088,1.088,0,0,1,19.625,11.5m0-1.5a2.625,2.625,0,1,0,2.625,2.625A2.625,2.625,0,0,0,19.625,10Z"
          transform="translate(-13.25 -7)"
          fill="var(--nonactionable-icon-color,#f5f6f8)"
        />
        <path
          id="Path_62011"
          data-name="Path 62011"
          d="M13.375,3.5A4.96,4.96,0,0,1,18.25,8.75c0,3-3.225,6.263-4.875,7.95C11.725,15.013,8.5,11.563,8.5,8.75A5.074,5.074,0,0,1,13.375,3.5m0-1.5A6.459,6.459,0,0,0,7,8.75c0,3.712,4.313,7.987,5.85,9.525a.712.712,0,0,0,1.05,0c1.538-1.538,5.85-5.738,5.85-9.525A6.415,6.415,0,0,0,13.375,2Z"
          transform="translate(-7 -2)"
          fill="var(--nonactionable-icon-color,#f5f6f8)"
        />
      </g>
    </svg>
  ),
  LocationCloseIcon: (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 48 48"
    >
      <g id="invisible_box" data-name="invisible box">
        <rect
          id="Rectangle_143618"
          data-name="Rectangle 143618"
          width="48"
          height="48"
          fill="none"
        />
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <path
          id="Path_70920"
          data-name="Path 70920"
          d="M26.8,24,37.4,13.5a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L24,21.2,13.4,10.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7L21.2,24,10.6,34.5a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L24,26.8,34.6,37.4a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7Z"
          fill="var(--nonactionable-icon-color,#f5f6f8)"
        />
      </g>
    </svg>
  ),
  instagram_save: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0H2C0.9 0 0 0.9 0 2V18L7 15L14 18V2C14 0.9 13.1 0 12 0ZM12 15L7 12.82L2 15V2H12V15Z"
        fill="var(--nonactionable-icon-color,#2D3E5C)"
      />
    </svg>
  ),
  instagram_save_white: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0H2C0.9 0 0 0.9 0 2V18L7 15L14 18V2C14 0.9 13.1 0 12 0ZM12 15L7 12.82L2 15V2H12V15Z"
        fill="var(--nonactionable-icon-color,#fff)"
      />
    </svg>
  ),
  money_sack_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 24 24"
    >
      <g>
        {/* Bag Top/Tie */}
        <path
          d="M 8 2 C 8.5 1.5, 10 1, 12 1 C 14 1, 15.5 1.5, 16 2 L 14.5 6 L 9.5 6 Z"
          fill="transparent"
          stroke="var(--nonactionable-icon-color,#2d3e5c)"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        {/* Bag Body */}
        <path
          d="M 9.5 6 C 6 10, 3 14, 3 18 C 3 21, 5 23, 9 23 L 15 23 C 19 23, 21 21, 21 18 C 21 14, 18 10, 14.5 6 Z"
          fill="transparent"
          stroke="var(--nonactionable-icon-color,#2d3e5c)"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        {/* Generic Currency Symbol */}
        <g fill="none" stroke="var(--nonactionable-icon-color,#2d3e5c)" strokeWidth="1.2" strokeLinecap="round">
          <circle cx="12" cy="14.5" r="3"/>
          <line x1="9.8" y1="12.3" x2="8.3" y2="10.8"/>
          <line x1="14.2" y1="12.3" x2="15.7" y2="10.8"/>
          <line x1="9.8" y1="16.7" x2="8.3" y2="18.2"/>
          <line x1="14.2" y1="16.7" x2="15.7" y2="18.2"/>
        </g>
      </g>
    </svg>
  ),
  money_sack_icon_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 24 24"
    >
      <g>
        {/* Bag Top/Tie */}
        <path
          d="M 8 2 C 8.5 1.5, 10 1, 12 1 C 14 1, 15.5 1.5, 16 2 L 14.5 6 L 9.5 6 Z"
          fill="transparent"
          stroke="var(--nonactionable-icon-color,#fff)"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        {/* Bag Body */}
        <path
          d="M 9.5 6 C 6 10, 3 14, 3 18 C 3 21, 5 23, 9 23 L 15 23 C 19 23, 21 21, 21 18 C 21 14, 18 10, 14.5 6 Z"
          fill="transparent"
          stroke="var(--nonactionable-icon-color,#fff)"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        {/* Generic Currency Symbol */}
        <g fill="none" stroke="var(--nonactionable-icon-color,#fff)" strokeWidth="1.2" strokeLinecap="round">
          <circle cx="12" cy="14.5" r="3"/>
          <line x1="9.8" y1="12.3" x2="8.3" y2="10.8"/>
          <line x1="14.2" y1="12.3" x2="15.7" y2="10.8"/>
          <line x1="9.8" y1="16.7" x2="8.3" y2="18.2"/>
          <line x1="14.2" y1="16.7" x2="15.7" y2="18.2"/>
        </g>
      </g>
    </svg>
  ),
};

export const getDynamicIconColor = (status = null) => {
  switch (status) {
    case "widgetHeaderFilterIcon":
    case "CommandCenterRefreshIcon":
    case "widgetHeaderFilterHoveredIcon":
    case "SettingsHoveredIcon":
    case "SettingsIcon":
    case "FollowersIcon":
    case "verifiedIcon": // hard coded blue
    case "trends_icon": // actionable icon
    case "clock_icon":
    case "close_cross_icon":
    case "delete_bin_icon":
    case "country_globe_icon":
    case "country_globe_icon_white":
    case "language_icon":
    case "replace_icon":
    case "replace_icon_white":
    case "edit_filter_icon_white":
    case "edit_filter_icon":
    case "personalization_icon":
    case "sort_by_icon":
    case "sort_by_icon_white":
    case "accordion_arrow":
    case "accordion_arrow_white":
    case "info_icon":
    case "play_icon":
    case "pause_icon":
    case "customize_brush_icon":
    case "alert_notification_icon":
    case "close_cross_icon_black":
    case "duration_icon_white":
    case "duration_icon":
    case "CategoryFilterIcon":
    case "LocationFilterIcon":
    case "LocationCloseIcon":
    case "instagram_save":
    case "instagram_save_white":
      return DynamicIconColor?.[status];
    default:
      return "";
  }
};
